import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc';
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds';
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector';
import { CompletionType } from 'root/src/shared/rewards/constants';
const responseLenses = getResponseLenses(GET_PROJECT);
const { viewCompletion } = responseLenses;
export const isSubmittable = (state, props) => {
    const completion = viewCompletion(getRecordSelector(state, props));
    return (completion === null || completion === void 0 ? void 0 : completion.type) !== CompletionType.GAME_INTEGRATED;
};
